import { copilotTeachingPopoverStore } from 'owa-iris-store';

export function getCampaignId(): string | null {
    let campaignPid: string | null = '';

    if (copilotTeachingPopoverStore().impressionBaseUri) {
        campaignPid = new URL(copilotTeachingPopoverStore().impressionBaseUri).searchParams.get(
            'PID'
        );
    }

    return campaignPid;
}
